<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<p class="ded"><a id="pagev"></a><em>For Rosey and Zook</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?3588d894